import { VehicleLayoutType } from './vehicle-layout-type';
import { VehicleDeviceLocation } from './vehicle-device-location';

export class VehicleLayout {

    vehicleLayoutId: number;
    layoutType: VehicleLayoutType;
    deviceLocations: VehicleDeviceLocation[];
}
